//
import EmployeeModel from '@/models/HumanResource/HrEmployee'

//
import { RequiredRule } from '@/mixins/reusable_mixins/rules'

/**
 * @description
 * Employee Loan Company Fields
 * 
 * hr_employee_id       Si  Int     ID del empleado al que se registra el préstamo
 * period_year_init     Si  Int     Periodo inicial (Año)
 * period_month_init    Si  Int     Periodo inicial (Mes)
 * quote_amount         Si  Int     Monto $ de la Cuota
 * quote_total          Si  Int     Cantidad total de cuotas
 */
export default [
    {
        name: 'hr_employee_id',
        type: 'autocomplete-model',
        props: {
            itemText: 'full_name',
            itemValue: 'id',
            label: 'Empleado',
            model: EmployeeModel,
            noObject: true,
            paramSearch: 'names',
            rules: [RequiredRule],
        },
    },
    {
        name: 'period',
        type: 'date-field',
        props: {
            pickerProps: {
                type: 'month'
            },
            label: 'Periodo',
            rules: [RequiredRule],
        },
    },
    {
        name: 'quote_amount',
        type: 'currency-field',
        props: {
            label: 'Monto de cuota',
            reverse: true,
            rules: [RequiredRule],
        },
    },
    {
        name: 'quote_total',
        type: 'float-field',
        props: {
            label: 'Cantidad de cuotas',
            reverse: true,
            rules: [RequiredRule],
        },
    },
]
